import { IXmlNode } from '@/app-modules/server-communications';
import { CatchUpData, ResetData, CallsData, NextGameData, PrizeData, BoxNumbersData } from '@/components/game/_domain';

class DefaultPrizeElement {
  public name: string;
  public prize: string;

  constructor(name: string, prize: string) {
    this.name = name;
    this.prize = prize;
  }
}

interface IPrizeStructure {
  readonly stakes: IPrizeStake[];
}

interface IPrizeStake {
  readonly stakeValue: number;
  readonly ticketBooks: IPrizeTicketBook[];
}

interface IPrizeTicketBook {
  readonly id: string;
  readonly name: string;
  readonly prizes: IPrizeElement[];
}

interface IPrizeElement {
  readonly name: string;
  readonly prize: number;
  readonly disablePrize: boolean;
  readonly isJackpot: boolean;
  readonly jackpotCalls: number;
}

interface IPrizeClassDescriptor {
  readonly callsDataClass?: new(node: IXmlNode) => CallsData;
  readonly catchUpDataClass?: new(node: IXmlNode) => CatchUpData;
  readonly nextGameDataClass?: new(node: IXmlNode) => NextGameData;
  readonly resetDataClass?: new(node: IXmlNode) => ResetData;
  readonly boxNumbersDataClass?: new(node: IXmlNode) => BoxNumbersData;
}

export {
  DefaultPrizeElement,
  IPrizeStructure,
  IPrizeTicketBook,
  IPrizeStake,
  IPrizeElement,
  IPrizeClassDescriptor
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_domain/models/prize-element.ts